import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-expand",
  "use": "icon-expand-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-expand\"><g fill=\"none\" fill-rule=\"evenodd\"><ellipse fill-opacity=\".6\" fill=\"#FFF\" cx=\"10.775\" cy=\"10.725\" rx=\"10.775\" ry=\"10.725\" /><g fill=\"#000\"><path d=\"M13.101 4.875v.293h2.66L11.75 9.16l.205.205 4.012-3.993V8.02h.293V4.875zM5.71 15.23l-.029-2.648h-.294l.045 3.145 3.159-.044-.015-.293-2.66.044 3.968-4.05-.22-.206z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol